// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Uploader_wrapper__1NPbj","inner":"Uploader_inner__2h5dr","text":"Uploader_text__1Feeg"};